import React from "react";

function LengthIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer rectangle */}
      <rect
        x="4"
        y="6"
        width="24"
        height="20"
        stroke="#2D2020"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      {/* Horizontal double arrow for length */}
      <path
        d="M8 16H24M11 13L8 16L11 19M21 13L24 16L21 19"
        stroke="#2D2020"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LengthIcon;
